import { TicketTypeInputs } from "../../../../enums/ticketType";

export interface GenerateInput<T> {
  id: number;
  name: string;
  label: string;
  type: TicketTypeInputs;
}

export let AddTicketItems: {
  id: number;
  section: string;
  data: GenerateInput<any>[];
}[] = [
  {
    id: 1,
    section: "TicketStep1",
    data: [
      { id: 1, name: "title", label: "Title", type: "text" },
      { id: 2, name: "companyId", label: "Company", type: "select" },
      { id: 3, name: "statusId", label: "Status", type: "statusId" },
      { id: 4, name: "categoryId", label: "Category", type: "select" },
      { id: 5, name: "departmentId", label: "Department", type: "select" },
      {
        id: 6,
        name: "interventionTypeId",
        label: "InterventionType",
        type: "select",
      },
      { id: 7, name: "locationId", label: "Location", type: "select" },
      {
        id: 8,
        name: "isMasterTicket",
        label: "IsMasterTicket",
        type: "checkbox",
      },
    ],
  },
  {
    id: 2,
    section: "TicketStep2",
    data: [
      { id: 1, name: "priorityId", label: "Priority", type: "select" },
      { id: 2, name: "customerId", label: "Customer", type: "select" },
      { id: 3, name: "contractorId", label: "Contractor", type: "select" },
      { id: 4, name: "dueDate", label: "DueDate", type: "date" },
      {
        id: 5,
        name: "assignedToId",
        label: "AssignedTo",
        type: "assignedToId",
      },
      { id: 6, name: "assetId", label: "Asset", type: "assetId" },
      {
        id: 7,
        name: "ticketFinancialType",
        label: "TicketFinancialType",
        type: "ticketFinancialType",
      },
      {
        id: 8,
        name: "phoneNo",
        label: "PhoneNo",
        type: "phone",
      },
      {
        id: 9,
        name: "financialAssignedToId",
        label: "FinancialAssignedTo",
        type: "financialAssignedToId",
      },
      {
        id: 10,
        name: "evidenceNeeded",
        label: "EvidenceNeeded",
        type: "checkbox",
      },
      {
        id: 11,
        name: "isRecurring",
        label: "Recurring",
        type: "checkbox",
      },
      {
        id: 12,
        name: "recurringPeriod",
        label: "RecurringPeriod",
        type: "select",
      },
      {
        id: 13,
        name: "recurringStartTime",
        label: "RecurringStartTime",
        type: "select",
      },
    ],
  },
  {
    id: 3,
    section: "TicketStep3",
    data: [
      {
        id: 1,
        name: "description",
        label: "Description",
        type: "multitext",
      },
      { id: 2, name: "formImages", label: "UploadPhoto", type: "photo" },
    ],
  },
];
